import React, { useEffect, useState } from 'react'
import styled, { useTheme } from 'styled-components'
import { ReactComponent as CloseIcon } from "../../Assets/iconsv2/generic/closeBtn.svg";
import _ from 'lodash';
import { useTranslate } from '@tolgee/react';
import { ReactComponent as CheckEmpty } from "../../Assets/iconsv2/generic/checkEmpty.svg"
import { ReactComponent as Check } from "../../Assets/iconsv2/generic/check.svg"
import PrimaryButton from '../GenericComponents/PrimaryButton';
import PrimaryButtonRemove from '../GenericComponents/PrimaryButtonRemove';
const Element = ({ element, selected, text, handleElementClick, purple, noBorder, readonly }) => {
    const theme = useTheme()
    return (
        <ElementWrapper onClick={readonly ? () => { } : (e) => handleElementClick(element)} noBorder={noBorder} readonly={readonly}>
            <ElementText purple={purple} >
                <p>{text}</p>
            </ElementText>
            <CustomCheckBox>
                {selected ? <CheckedWrapper>
                    <Check />
                </CheckedWrapper> :
                    <CheckEmptyWrapper>
                        <CheckEmpty />
                    </CheckEmptyWrapper>}
            </CustomCheckBox>
        </ElementWrapper>
    )
}

const DeleteReasonsModal = ({ handleClose, setDeleteConfirmationOpen, selectedReasons, setSelectedReasons }) => {

    const [confirmation, setConfirmation] = useState(null)
    const { t } = useTranslate();
    const reasonsList = [
        {
            reason: t('delete_account_modal.reason1'),
            reason_id: 1
        },
        {
            reason: t('delete_account_modal.reason2'),
            reason_id: 2
        },
        {
            reason: t('delete_account_modal.reason3'),
            reason_id: 3
        },
        {
            reason: t('delete_account_modal.reason4'),
            reason_id: 4
        },
        {
            reason: t('delete_account_modal.reason5'),
            reason_id: 5
        },
    ]

    const confirmationElement = {
        reason: "Confirmation",
        reason_id: 9
    }

    const handleElementClick = (element) => {
        let found = selectedReasons.find((item) => item.reason_id === element.reason_id)
        if (found) {
            let filtered = selectedReasons.filter((item) => item.reason_id != element.reason_id)
            setSelectedReasons(filtered)
        }
        else {
            setSelectedReasons((prev) => {
                return [...prev, element]
            })
        }
    }

    const handleConfirmation = (element) => {

        if (_.isEqual(confirmation, element)) {
            setConfirmation(null)
        } else {
            setConfirmation(element)
        }
    }

    useEffect(() => {
        const keyDownHandler = event => {
            if (event.key === 'Escape') {
                event.preventDefault();
                // 👇️ your logic here
                handleClose();
            }
        };

        document.addEventListener('keydown', keyDownHandler);

        return () => {
            document.removeEventListener('keydown', keyDownHandler);
        };
    }, []);

    return (
        <FullScreenContainer>
            <Card>
                <Header>
                    <Text>
                        <h1>{t('delete_account_modal.delete')}</h1>
                    </Text>
                    <CloseBtn onClick={handleClose}>
                        <CloseIcon />
                    </CloseBtn>
                </Header>
                <InfoText>
                    <p>{t('delete_account_modal.are_you_sure')}</p>
                    <p>{t('delete_account_modal.action')}</p>
                    <p>{t('delete_account_modal.specifically')}</p>
                </InfoText>
                <InfoText>
                    <h1>{t('delete_account_modal.reasons')}</h1>
                    <p>{t('delete_account_modal.reasons_info')}</p>
                </InfoText>
                <Content>
                    {reasonsList.map((element) => (
                        <Element
                            key={element.id}
                            text={element.reason}
                            element={element}
                            handleElementClick={handleElementClick}
                            selected={selectedReasons.find((item) => item.reason_id === element.reason_id)}
                        />
                    ))}
                </Content>
                <InfoText>
                    <h1>{t('delete_account_modal.confirmation')}</h1>
                    <Element
                        element={confirmationElement}
                        handleElementClick={handleConfirmation}
                        purple
                        noBorder
                        text={t('delete_account_modal.i_want')}
                        selected={confirmation?.reason_id === confirmationElement.reason_id}
                    />
                </InfoText>
                <PrimaryButtonRemove
                    style={{ padding: "16px" }}
                    disabled={selectedReasons.length == 0 || !confirmation}
                    onClick={() => setDeleteConfirmationOpen(true)}
                >
                    {t('profile.delete_account')}
                </PrimaryButtonRemove>
            </Card>
        </FullScreenContainer>
    )
}

export default DeleteReasonsModal
const FullScreenContainer = styled.div`
display:flex;
align-items:center;
justify-content:center;
position:fixed;
width:100%;
height:100%;
background:rgba(0,0,0,0.3);
left:0;
top:0;
padding:5vh 40vw;
z-index:2;
`
const Card = styled.div`
display:flex;
flex-direction:column;
gap:30px;
padding:25px 20px;
background:${({ theme }) => theme.menu.background};
width:100%;
height:fit-content;
min-width:600px;
border-radius:4px;
max-height:100%;
overflow:auto;
`
const Header = styled.div`
display:flex;
justify-content:space-between;

`
const CloseBtn = styled.button`
display:flex;
align-items:center;
justify-content:center;
border:none;
background:none;
cursor:pointer;
svg{
height:26px;
width:26px;
color:${({ theme }) => theme.menu.selectedOpionBackground};
stroke:${({ theme }) => theme.sidebar.borderColor};
}
`
const Text = styled.div`
  display: flex;
  flex-direction: column;
  gap: px;
overflow:hidden;
h1{
  text-transform:capitalize;
    color:${({ theme }) => theme.menu.primaryTextColor};
font-size: 20px;
font-weight: 500;
line-height: 30px;
text-align: left;

}
`;
const Content = styled.div`
display:flex;
flex-direction:column;
height:100%;
overflow:auto;

`
const InfoText = styled.div`
display:flex;
flex-direction:column;
gap:10px;
p{
color:${({ theme }) => theme.menu.secondaryTextColor};
font-size: 14px;
font-weight: 500;
line-height: 18px;
text-align: left;
}
h1{
    text-transform:capitalize;
 font-size: 14px;
    font-weight: 500;
    line-height: 22px;
  text-align: left;
  color: ${({ purple, theme }) => purple ? theme.menu.selectedTextColor : theme.menu.primaryTextColor};
  width: 100%;
  
  }
`
const CustomCheckBox = styled.div`
margin-left:auto;
display:flex;

svg{
max-width:25px;
max-height:25px;
fill:transparent;
color:transparent;
}

`;

const ElementWrapper = styled.div`
display:flex;
z-index:1;
align-items:center;
border-bottom:${({ noBorder, theme }) => noBorder ? "none" : ` 1px solid ${theme.sidebar.borderColor}`};
cursor:${({ readonly }) => readonly ? "inherit" : "pointer"};
`
const ElementText = styled.div`
display: flex;
align-items: center;
padding: 15px 0;
p {
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  text-align: left;
  color: ${({ purple, theme }) => purple ? theme.menu.selectedTextColor : theme.menu.primaryTextColor};
  width: 100%;
}

`



const CheckedWrapper = styled.div`
display:flex;
svg{
color:${({ theme }) => theme.check.background};
fill:${({ theme }) => theme.check.checkSign};
}
`
const CheckEmptyWrapper = styled.div`
display:flex;
svg{
color:${({ theme }) => theme.check.border};
stroke:${({ theme }) => theme.check.checkSign};
}
`